import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

const Footer = () => {
  let [loggedinuser] = useState(JSON.parse(localStorage.getItem("user")));
  const [statusBar, setStatusBar] = useState([]);
  const loadPaging = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/statusbar", {
          headers: {
            "mojo-access-tokens": loggedinuser.token,
          },
        })
        .then((response) => {
          setStatusBar(response.data);
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadPaging();
  }, []);

  return (
    <>
      {loggedinuser.role === "Editor" || loggedinuser.role === "Admin" ? (
        <footer className="sticky-footer">
          {statusBar.length ? (
            <div className="row text-center">
              <div className="col-md-1 col-1">
                <b>Last 24 Hours</b>
              </div>
              {statusBar.map((item) => (
                <div className="col-md-1 col-1">
                  <b>{item.post_type}</b>
                  <br />
                  <span className="alert-danger"> {item.status}</span>
                  <br /> {item.cnt}
                </div>
              ))}
            </div>
          ) : (
            <div className="col-md-10 text-center text-danger">
              No record found for last 24 hours
            </div>
          )}
        </footer>
      ) : (
        ""
      )}
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      &nbsp;
      {/* <footer className="br-footer">
        <div className="footer-left">
          <div className="mg-b-2">
            Copyright © 2022. TV9. All Rights Reserved.
          </div>
          <div>Attentively and carefully made by TV9 Digital Team</div>
        </div>
        <div className="footer-right d-flex align-items-center">
          <span className="tx-uppercase mg-r-10">Share:</span>
          <a
            target="_blank"
            rel="noreferrer"
            className="pd-x-5"
            href="https://www.facebook.com/TV9Bharatvarsh/"
          >
            <i className="fa fa-facebook tx-20" />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            className="pd-x-5"
            href="https://twitter.com/Tv9Bharatvarsh?s=08"
          >
            <i className="fa fa-twitter tx-20" />
          </a>
        </div>
      </footer> */}
    </>
  );
};

export default Footer;
